import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";
import "./Dropdown.css";

export type DropdownOption = { value: string; label: string };

// Custom styled select replacement: keyboard/click, search-free, theme-aware.
const Dropdown = ({
    value,
    options,
    onChange,
    placeholder = "Select…",
    label,
}: {
    value: string;
    options: DropdownOption[];
    onChange: (value: string) => void;
    placeholder?: string;
    label?: string;
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const onDocClick = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    const selected = options.find((o) => o.value === value);

    return (
        <div className="zv-dropdown" ref={ref}>
            {label ? <span className="zv-dd-label">{label}</span> : null}
            <button type="button" className={`zv-dd-trigger ${open ? "open" : ""}`} onClick={() => setOpen((o) => !o)}>
                <span className={selected ? "" : "zv-dd-placeholder"}>{selected ? selected.label : placeholder}</span>
                <FontAwesomeIcon icon={faChevronDown} className={`zv-dd-caret ${open ? "up" : ""}`} />
            </button>
            {open ? (
                <div className="zv-dd-menu">
                    {options.map((o) => (
                        <div
                            key={o.value || "__all"}
                            className={`zv-dd-option ${o.value === value ? "active" : ""}`}
                            onClick={() => { onChange(o.value); setOpen(false); }}
                        >
                            <span>{o.label}</span>
                            {o.value === value ? <FontAwesomeIcon icon={faCheck} className="zv-dd-tick" /> : null}
                        </div>
                    ))}
                    {!options.length ? <div className="zv-dd-empty">—</div> : null}
                </div>
            ) : null}
        </div>
    );
};

export default Dropdown;
